import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import VisibilityIcon from '@material-ui/icons/Visibility';
import { Box, Container, Card, CardContent, CardHeader, makeStyles} from "@material-ui/core";
import AssigmentsByMinutesPerUser from "../UserManagement/AssigmentsByMinutesPerUser";
import ClosuresByMinutesPerUser from "../UserManagement/ClosuresByMinutesPerUser";
import axiosConfig from "../../axiosConfig";
import Loading from "../Loading/loading";
import { Card as Card2, CardHeader as CardHeader2} from "../../shared/Card/Index";
import styles from "../../shared/dashboardStyle";
import * as headers from "../../shared/language.json";

const useStyles = makeStyles(styles);

function MyProfile({ props, className, ...rest }) {
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(true);

  let history = useHistory();
  const classes = useStyles();


  const handleShowPassword = () => {
    setShowPassword(!showPassword)
  }
  useEffect(() => {
    if (typeof rest.location.selected != "undefined") {
      const promise1 = axiosConfig.get(
        `/User/GetUserById/${rest.location.selected}`
      );
      axios
        .all([promise1])
        .then(
          axios.spread((...res) => {
            const responseOne = res[0];
            formik.setValues(responseOne.data);

            setLoading(false);
          })
        )
        .catch((err) => {
          console.log(err);
        });
    } else {
      history.goBack();
    }
  }, []);

  const formik = useFormik({
    initialValues: {
      email: "",
      firstname: "",
      lastname: "",
      role: "",
      previousPassword: "",
      newPassword: "",
      verifyNewPassword: "",
    },
    validationSchema: Yup.object({
      previousPassword: Yup.string().required(
        headers.FORMIKERRORMESSAGES.REQUIRED
      ),
      newPassword: Yup.string().required(headers.FORMIKERRORMESSAGES.REQUIRED),
      verifyNewPassword: Yup.string().oneOf(
        [Yup.ref("newPassword"), null],
        headers.FORMIKERRORMESSAGES.PASSWORDSMUSTMATCH
      ),
    }),
    onSubmit: (values) => {
      Swal.fire({
        title: "",
        text: "Παρακαλούμε επιβεβαιώστε την καταχώρηση σας",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ναι",
        cancelButtonText: "Οχι",
        showLoaderOnConfirm: true,
        closeOnClickOutside: false,
        preConfirm: () => {
          return axiosConfig
            .put("/User/UpdateUserPassword", {
              userId: rest.location.selected,
              previousPassword: values.previousPassword,
              newPassword: values.newPassword,
              verifyNewPassword: values.verifyNewPassword,
            })
            .then((res) => {
              if (res.status === 200) {
                Swal.fire("Η καταχώρηση ήταν επιτυχής", "", "success");
                history.goBack();
              }
            })
            .catch((error) => {
              Swal.showValidationMessage(`Η καταχώρηση ήταν ανεπιτυχής`);
            });
        },
        allowOutsideClick: () => !Swal.isLoading(),
      });
    },
  });

  if (loading === false) {
    return (
      <div>
        <Container maxWidth="lg">
          <Card2>
            <CardHeader2 color="warning">
              <h1 className={classes.cardTitleWhite}>Ο Λογαριασμός μου</h1>
            </CardHeader2>
            {/* <CardBody> */}
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={8}>
                <Box mt={3}>
                  <Card>
                    <CardHeader
                      subheader="Τα παρακάτω πεδία δεν γίνεται να τροποποιηθούν."
                      title="Τα στοιχεία μου"
                    />
                    <Divider />
                    <CardContent>
                      <Grid container spacing={6} wrap="wrap">
                        <Grid item xs={12} sm={12} md={6}>
                          <TextField
                            type="email"
                            required
                            id="email"
                            name="email"
                            label="Email"
                            fullWidth
                            disabled
                            variant="outlined"
                            value={formik.values.email}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <TextField
                            type="text"
                            required
                            id="firstname"
                            name="firstname"
                            label="Όνομα"
                            fullWidth
                            disabled
                            variant="outlined"
                            value={formik.values.firstname}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <TextField
                            type="text"
                            required
                            id="lastname"
                            name="lastname"
                            label="Επώνυμο"
                            fullWidth
                            variant="outlined"
                            disabled
                            value={formik.values.lastname}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <TextField
                            type="text"
                            required
                            id="role"
                            name="role"
                            label="Ρόλος"
                            fullWidth
                            disabled
                            variant="outlined"
                            value={formik.values.role}
                          />
                        </Grid>
                      </Grid>
                    </CardContent>
                    <Divider />
                  </Card>
                </Box>
                <Box mt={3}>
                  <Card>
                    <CardHeader subheader="Κωδικός" title="Αλλαγή Κωδικού" />
                    <Divider />
                    <CardContent>
                      <Grid container spacing={6} wrap="wrap">
                        <Grid item xs={12} sm={12} md={4}>
                          <TextField
                            id="previousPassword"
                            name="previousPassword"
                            label="Κωδικός Χρήστη"
                            type="password"
                            fullWidth
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.previousPassword}
                          />
                          {formik.touched.Password &&
                          formik.errors.previousPassword ? (
                            <span style={{ color: "red" }}>
                              {formik.errors.previousPassword}
                            </span>
                          ) : null}
                        </Grid>
                        <Grid item xs={12} sm={12} md={4}>
                          <TextField
                            id="newPassword"
                            name="newPassword"
                            label="Νέος Κωδικός Χρήστη"
                            type={showPassword ? "text" : "password"} 
                            fullWidth
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.newPassword}
                            InputProps={{
                              endAdornment: (
                                <Button onClick= {handleShowPassword}>
                                <VisibilityIcon />
                                </Button>
                              )
                            }}
                          />
                          {formik.touched.newPassword &&
                          formik.errors.newPassword ? (
                            <span style={{ color: "red" }}>
                              {formik.errors.newPassword}
                            </span>
                          ) : null}
                        </Grid>
                        <Grid item xs={12} sm={12} md={4}>
                          <TextField
                            id="verifyNewPassword"
                            name="verifyNewPassword"
                            label="Επιβεβαίωση Κωδικού Χρήστη"
                            type="password"
                            fullWidth
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.verifyNewPassword}
                          />
                          {formik.touched.verifyNewPassword &&
                          formik.errors.verifyNewPassword ? (
                            <span style={{ color: "red" }}>
                              {formik.errors.verifyNewPassword}
                            </span>
                          ) : null}
                        </Grid>
                      </Grid>
                    </CardContent>
                    <Divider />
                    <Box display="flex" justifyContent="flex-end" p={2}>
                      <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={formik.handleSubmit}
                      >
                        Αποθηκευση
                      </Button>
                    </Box>
                  </Card>
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <AssigmentsByMinutesPerUser />
                <ClosuresByMinutesPerUser />
              </Grid>
            </Grid>
          </Card2>
        </Container>
      </div>
    );
  } else {
    return <Loading></Loading>;
  }
}

export default MyProfile;
